export interface ColumnFilter { index: string; label: string; options: Array<{ value: string; label: string }> }
const categorical = /role|status|state|city|counter|supplier|sales rep|reports to|level|product|actor|action|entity|type|route|batch|audience|category|method|holder|published by/i;
const actionable = (label: string) => /^actions?$/i.test(label.trim());

export function columnFilters(headings: string[], rows: string[][]): ColumnFilter[] {
  const hasCategories = headings.some((label) => categorical.test(label) && !actionable(label));
  const first = headings.findIndex((label) => Boolean(label.trim()) && !actionable(label));
  return headings.flatMap((label, index) => {
    if ((hasCategories ? !categorical.test(label) : index !== first) || actionable(label)) return [];
    const values = [...new Set(rows.map((row) => row[index]?.trim() ?? ""))].sort((a, b) => a.localeCompare(b));
    return values.length ? [{ index: String(index), label, options: values.map((value) => ({ value: value || "__empty", label: value || "Not set" })) }] : [];
  });
}

export function matchesColumnFilters(cells: string[], filters: Record<string, string>): boolean {
  return Object.entries(filters).every(([index, value]) => (cells[Number(index)]?.trim() || "__empty") === value);
}
